<!--  -->
<template>
  <div class="shownew">
    <div class="box">
      <ul class="left" >
        <li class="title">
          <h2>课题研究服务</h2>
          <p>广泛的课程研究,对整体的企业资源进行有效的配置,管理,控制和优化,实现企业价值最大化。</p>
        </li>
        <template v-if="articles && articles.length > 0">
          <li class="item" v-for="(article, index) in articles" :key="index" >    
          <router-link tag="p" :to="`/views/info/${article.plateid}/${article._id}`">{{ article.title }}</router-link> 
          <span>{{ article.addtime | dateFormat }}</span>  
          </li>
        </template>
      </ul>
      <!-- <ul class="right">
        <router-link class="btnitem" to="/login" style="background:url(/static/img/hangshehui.png);"></router-link>
        <router-link to="/login" class="btnitem" style="background:url(/static/img/zhiye.png);">
        </router-link>
        <router-link to="/inquery" class="btnitem" style="background:url(/static/img/zhiyexinxi.png);">
        </router-link>
      </ul> -->
    </div>
    
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  filters: {
    dateFormat: function (date) {
      return date?date.substring(0,10):""
    }
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="课题研究服务"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=5&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
        }
    });
  }
}
</script>
<style scoped>
.shownew{
  width: 100% !important;
  margin: 64px auto 0;
  height: 689px;
  background-image: url(/static/img/zhieyebabg.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.box{
  width: 1200px;
  height: 689px;
  margin: 0 auto;
  overflow: hidden;
}
.left{
  margin-top: 62px;
  height: 370px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
}
.left .title{
  box-sizing: border-box;
  width: 380px;
  height: 171px;
  margin-bottom: 27px;
}
.left .title h2{
  padding-left: 8px;
    height: 28px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 28px;
}
.left .title p{
  margin-top: 34px;
  padding-left: 9px;
  width: 317px;
  height: 70px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 25px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.left .item{
  position: relative;
 box-sizing: border-box;
 margin-bottom: 27px;
  width: 380px;
  height: 171px;
  background-color: #F8FAFC;
  background-image: url(/static/img/wuxingbaozhan.png);
  background-repeat: no-repeat;
  background-size: 32px 39px;
  background-position: 20px 33px;
}
.left .item p{
  position: absolute;
  top:31px;
  left:76px;
  width: 281px;
height: 45px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
line-height: 25px;
overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.left .item span{
  position: absolute;
  top:123px;
  left:76px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
color: #999999;
line-height: 18px;
}
.right{
  margin-top: 40px;
  width: 1200px;
height: 150px;
display: flex;
justify-content: space-between;
}
.right .btnitem{
  position: relative;
  width: 380px;
height: 150px;;
}
</style>